import { random } from "lodash";
import React, { useState, useEffect } from "react";

const ViewMode = {
  Hour: "hour",
  QuarterDay: "quarter_day",
  HalfDay: "half_day",
  Day: "day",
  Week: "week",
  Month: "month",
  Year: "year",
  QuarterYear: "quarter_year",
};

export function getStartEndDateForProject(tasks, projectId) {
  const projectTasks = tasks.filter(t => t.project === projectId);

  if(projectTasks.length < 1){
    const project = tasks.find(t => t.id === projectId);
    // Validate project dates
    const projectStart = project?.start instanceof Date && !isNaN(project.start.getTime()) ? project.start : new Date();
    const projectEnd = project?.end instanceof Date && !isNaN(project.end.getTime()) ? project.end : new Date(projectStart.getTime() + 24 * 60 * 60 * 1000);
    return [projectStart, projectEnd];
  }

  let start = projectTasks[0].start;
  let end = projectTasks[0].end;
  
  // Validate initial dates
  if (!(start instanceof Date) || isNaN(start.getTime())) {
    start = new Date();
  }
  if (!(end instanceof Date) || isNaN(end.getTime())) {
    end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
  }

  for (let i = 0; i < projectTasks.length; i++) {
    const task = projectTasks[i];
    const taskStart = task.start instanceof Date && !isNaN(task.start.getTime()) ? task.start : start;
    const taskEnd = task.end instanceof Date && !isNaN(task.end.getTime()) ? task.end : end;
    
    if (start.getTime() > taskStart.getTime()) {
      start = taskStart;
    }
    if (end.getTime() < taskEnd.getTime()) {
      end = taskEnd;
    }
  }
  return [start, end];
}

export function getTotalProjectProgress(tasks, projectId, start, end) {
  const MS_PER_DAY = 1000 * 60 * 60 * 24;

  let totalWeightedProgress = 0;
  let totalDuration = 0;

  const projectTasks = tasks.filter(t => t.project === projectId);
  projectTasks.forEach(task => {
    // Validate task dates before calculation
    const taskStart = task.start instanceof Date && !isNaN(task.start.getTime()) ? task.start : new Date();
    const taskEnd = task.end instanceof Date && !isNaN(task.end.getTime()) ? task.end : new Date(taskStart.getTime() + 24 * 60 * 60 * 1000);
    
    const durationInMs = taskEnd - taskStart;
    const duration = durationInMs / MS_PER_DAY;
    const progress = (task.progress || 0) / 100;

    totalWeightedProgress += duration * progress;
    totalDuration += duration;
  });

  if (totalDuration === 0) return 0;

  const overallProgress = (totalWeightedProgress / totalDuration) * 100;

  return overallProgress.toFixed(2); // percentage with 2 decimals
}
